module.exports = __webpack_public_path__ + "static/media/IconHelp.f243047c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/IconHelp.svg
// module id = 943
// module chunks = 0